// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__QAk4P","messages":"Chat_messages__1xToS","dateDivider":"Chat_dateDivider__2Lz_l"};